window.addEventListener("tangent:quiz:initialized", (e)=>{
    const shadowRoot = document.querySelector("#tangent-chatbot-container").shadowRoot;
    if(!shadowRoot) return;
    const style = document.createElement("style");
    style.textContent = `
    .tangent_chat_response_custom::before {
        content: '';
        width: 8px;
        height: 8px;
        border: 1px solid #fff;
        background: #fff;
        border-radius: 999px;
        display: block;
    }
    .tangent_chat_cta_custom::before {
        content: '';
        width: 8px;
        height: 8px;
        border: 1px solid #fff;
        background: transparent;
        border-radius: 999px;
        display: block;
    }
    .tangent_chat_option_custom::before {
        content: '';
        width: 8px;
        height: 8px;
        border: 1px solid #fff;
        background: transparent;
        border-radius: 999px;
        display: block;
    }
    `;

    shadowRoot.appendChild(style);
    // setTimeout(() => {
    //     const button = shadowRoot.querySelector('button');
    //     const svg = button.querySelector('svg');

    //     if (svg) {
    //         const img = document.createElement('img');
    //         img.src = 'https://cdn.shopify.com/s/files/1/0144/3636/8419/files/send_icon_3350e234-956a-47fe-88a3-ada8b34a753b.png';
    //         img.alt = 'Chat';
    //         img.width = 24;
    //         img.height = 24;

    //         svg.replaceWith(img);
    //     }
    // }, 1000);
})

const handleBtnClick = () => {
    const host = document.querySelector('#tangent-chatbot-container');
    if (!host?.shadowRoot) return;
    const bubble = host.shadowRoot.querySelector('.tangent_chat_chatbubble_custom');
    bubble?.click();
}

(() => {
    const initVideoEndChat = () => {
        const video = document.querySelector('[data-tangent-video]');
        if (!video) return;

        video.addEventListener('ended', handleBtnClick);
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initVideoEndChat);
    } else {
        initVideoEndChat();
    }
})();

const handleBackButton = () => {
    const host = document.querySelector('#tangent-chatbot-container');
    if (!host?.shadowRoot) return;
    const closeBtn = host.shadowRoot.querySelector('.tangent_chat_header_close_button_custom');
    closeBtn.dispatchEvent(new Event("click", {bubbles:true}))
}

/*********************** Code to handle options that are answered previously ***********************/
(function() {
    var HOST_ID = "tangent-chatbot-container";

    // Questions that share the same option list (fake multi-select).
    // Add/edit these strings to match the quiz config questionText exactly
    // (after whitespace normalize — see cleanLabel).
    var RELATED_QUESTION_GROUPS = [
        [
            "How is your scalp health?",
            "Is there anything else you notice about your scalp?",
            "How do you typically wear your hair?",
            "What's another way you often wear your hair?",
            "And is there another way you like to wear your hair?",
            "What is your main hair concern?",
            "What's another hair concern you'd like to address?",
            "Is there one more hair concern you'd like to address?",
            "What's your main styling goal?",
            "What's another styling goal you'd like to achieve?",
            "Is there one more styling goal you'd like to achieve?"
        ]
        // Add more groups here if needed:
        // [ "Question A v1", "Question A v2" ]
    ];

    var RESPONSE_SEL = ".tangent_chat_response_custom";
    var OPTION_CONTAINER_SEL = ".tangent_chat_option_container_custom";
    var OPTION_SEL = ".tangent_chat_option_custom";

    function getShadowRoot() {
        var host = document.getElementById(HOST_ID);
        return host && host.shadowRoot ? host.shadowRoot : null;
    }

    function cleanLabel(el) {
        if (!el) return "";
        var clone = el.cloneNode(true);
        var svgs = clone.querySelectorAll("svg");
        for (var i = 0; i < svgs.length; i++) svgs[i].remove();
        return (clone.textContent || "").replace(/\s+/g, " ").trim();
    }

    // Normalize for matching config strings to rendered HTML question text.
    function normalizeText(text) {
        return (text || "")
            .replace(/[\u2018\u2019\u02BC\uFF07]/g, "'")
            .replace(/\s+/g, " ")
            .trim();
    }

    // If this question belongs to a related group, return that group; else null.
    function findGroup(questionText) {
        var q = normalizeText(questionText);
        for (var g = 0; g < RELATED_QUESTION_GROUPS.length; g++) {
            var group = RELATED_QUESTION_GROUPS[g];
            for (var i = 0; i < group.length; i++) {
                if (normalizeText(group[i]) === q) return group;
            }
        }
        return null;
    }

    function isInGroup(questionText, group) {
        var q = normalizeText(questionText);
        for (var i = 0; i < group.length; i++) {
            if (normalizeText(group[i]) === q) return true;
        }
        return false;
    }

    function findPrecedingQuestion(el) {
        var node = el.previousElementSibling;
        while (node) {
            if (node.classList && node.classList.contains("tangent_chat_question_custom")) {
                return node;
            }
            node = node.previousElementSibling;
        }
        return null;
    }

    // Collect answers only from questions in the same related group as `group`.
    function collectSelectedForGroup(root, group) {
        var selected = {};
        var responses = root.querySelectorAll(RESPONSE_SEL);

        for (var i = 0; i < responses.length; i++) {
            var response = responses[i];
            var questionText = cleanLabel(findPrecedingQuestion(response));
            var answerText = cleanLabel(response);

            if (!questionText || !answerText) continue;
            if (!isInGroup(questionText, group)) continue;

            selected[answerText] = true;
        }

        return selected;
    }

    function hideAlreadyAnsweredOptions(root) {
        var containers = root.querySelectorAll(OPTION_CONTAINER_SEL);

        for (var c = 0; c < containers.length; c++) {
            var container = containers[c];
            var questionText = cleanLabel(findPrecedingQuestion(container));
            var group = findGroup(questionText);

            // Only apply hide logic for questions that are part of a related group.
            if (!group) continue;

            var selected = collectSelectedForGroup(root, group);
            var options = container.querySelectorAll(OPTION_SEL);

            for (var j = 0; j < options.length; j++) {
                var option = options[j];
                var label = cleanLabel(option);
                var shouldHide = !!(label && selected[label]);

                if (shouldHide) {
                    option.style.display = "none";
                } else if (option.style.display === "none") {
                    option.style.display = "";
                }
            }
        }
    }

    function start() {
        var root = getShadowRoot();
        if (!root) return false;

        var scheduled = false;

        function run() {
            scheduled = false;
            hideAlreadyAnsweredOptions(root);
        }

        function schedule() {
            if (scheduled) return;
            scheduled = true;
            requestAnimationFrame(run);
        }

        schedule();
        new MutationObserver(schedule).observe(root, {
            childList: true,
            subtree: true
        });
        return true;
    }

    if (!start()) {
        var tries = 0;
        var wait = setInterval(function() {
            tries += 1;
            if (start() || tries > 100) clearInterval(wait);
        }, 300);
    }
})();